import { render, staticRenderFns } from "./ListFranchisee.vue?vue&type=template&id=24777813"
import script from "./ListFranchisee.vue?vue&type=script&lang=js"
export * from "./ListFranchisee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports